export default "__VITE_ASSET__96a7e6bf__"